<template>
  <div>
    <Header :title="title" :showBack="true"></Header>
    <iframe :src="StatementUrl" v-if="StatementUrl!=''" width="100%" height="900px" style="overflow: auto;"></iframe>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header
  },
  data() {
    return {
      title: "路单预览", //标题
      StatementUrl: this.$route.query.StatementUrl
    };
  },
  watch: {},
  methods: {},
  mounted: function() {},
  created() {}
};
</script>

